import { createIamSessionClient } from "@itaas/core/auth/iam-session.service";
import {
  resolveSpecialtyDemoTenantFromEmail,
  findSpecialtyDemoBySlug,
} from "@itaas/core/demo/demo-tenants.catalog";
import type { LoginCredentials } from "@itaas/core/auth/auth.types";
import type { AuthSession } from "@itaas/core/auth/models/session.model";
import { iamRequest } from "@/core/api/iam-client";
import { IAM_TENANT_SLUG } from "@/core/config";

const iam = createIamSessionClient({
  iamRequest,
  tenantSlug: IAM_TENANT_SLUG,
  defaultTenantName: "Établissement",
  resolveTenantSlug: (email) =>
    resolveSpecialtyDemoTenantFromEmail(email) ?? IAM_TENANT_SLUG,
  resolveTenantDisplayName: (slug) => findSpecialtyDemoBySlug(slug)?.name,
});

export const pharmacySessionApi = iam;

export function pharmacyLogin(credentials: LoginCredentials): Promise<AuthSession> {
  return iam.login(credentials);
}

export function pharmacyLogout(): Promise<void> {
  return iam.logout();
}

export function pharmacyRefreshToken(refreshToken: string) {
  return iam.refreshToken(refreshToken);
}

export function pharmacyVerifySession(): Promise<AuthSession | null> {
  return iam.verifySession();
}

export {
  changePassword,
  forgotPassword,
  resetPassword,
} from "@itaas/core/auth/auth.service";
